module.exports = __webpack_public_path__ + "media/images/features/7/schedule-3-be90a44ea3eee4dd3578c77c6993c0b6.jpg";